import * as PropTypes from 'prop-types'

const AutomationShape = PropTypes.shape({

})

export { AutomationShape }
